const mobileNavNew = () => {
  // Elements
  const mainContent = document.querySelector('#main-content');
  const pageHeader = document.querySelector('header');
  const mobileMenu = pageHeader.querySelector('.nav-wrapper-mobile');
  const toggleMenu = document.querySelector('.menu-button');
  if (!mobileMenu || !toggleMenu) {
    return;
  }
  const menuWrapper = document.querySelector('.menu-wrapper');
  const level1Links = pageHeader.querySelectorAll('.level-1 > li > button');
  // const primaryItems = pageHeader.querySelectorAll('.primary-item');
  const listWrapper2 = pageHeader.querySelector('.level-2-wrapper');
  // const subMenu2Heading = listWrapper2.querySelector('.sub-menu-title');
  const listWrapper3 = pageHeader.querySelector('.level-3-wrapper');
  // const subMenu3Heading = listWrapper3.querySelector('.sub-menu-title');
  // const subMenuWrapper2 = listWrapper2.querySelector('.sub-menu-wrapper');
  // const subMenuWrapper3 = listWrapper3.querySelector('.sub-menu-wrapper');
  const backOneLevelBtns = pageHeader.querySelectorAll('.back-one-level');
  const listWrappers = [...document.querySelectorAll('.list-wrapper')];
  const isVisibleClass = 'is-visible';
  const isActiveClass = 'is-active';

  const toggleMobileMenu = () => {
    menuWrapper.classList.toggle(isVisibleClass);
    mobileMenu.classList.toggle('menu-open');
    if (!menuWrapper.classList.contains('menu-open')) {
      toggleMenu.setAttribute('aria-expanded', 'true');
    } else {
      toggleMenu.setAttribute('aria-expanded', 'false');
    }
    if (!toggleMenu.classList.contains(isVisibleClass)) {
      listWrapper2.classList.remove(isVisibleClass);
      listWrapper3.classList.remove(isVisibleClass);
      const menuLinks = menuWrapper.querySelectorAll('a');
      menuLinks.forEach((menuLink) => {
        menuLink.classList.remove(isActiveClass);
      });
    }
  };

  toggleMenu.addEventListener('click', () => {
    toggleMobileMenu();
  });
  // toggle the menu closed if the focus goes outside of the menu-wrapper
  document.addEventListener('keydown', () => {
    if (menuWrapper.classList.contains(isVisibleClass) && mainContent.contains(document.activeElement)) {
      toggleMobileMenu();
    }
  });

  const resetFocus = (el) => {
    const timer = setTimeout(() => {
      // console.log(el);
      const elToFocus = el.querySelector('.back-one-level') || el.querySelector('.subnav-toggle');
      // console.log(elToFocus);
      elToFocus.focus();
      clearTimeout(timer);
    }, 300);
  };

  const buildSubNav = (e, linkClicked, tabbed) => {
    e.preventDefault();
    // get the current List Wrapper
    const currentListContent = linkClicked.nextElementSibling;
    const currentListWrapper = linkClicked.closest('.list-wrapper');
    // console.log(currentListWrapper);
    if (currentListWrapper) {
      // find the index of that wrapper in the listWrappers []
      const currentIndex = listWrappers.indexOf(currentListWrapper);

      // Give that clicked link the aria-expand true and the is-active class.
      linkClicked.classList.add(isActiveClass);
      linkClicked.setAttribute('aria-expanded', 'true');

      // clone the node from the original structure and place it into the next listWrapper
      const clonedList = currentListContent.cloneNode(true);

      // set the next active wrapper to the next in the array.
      const nextListWrapper = listWrappers[currentIndex + 1];
      nextListWrapper.classList.add(isVisibleClass);
      nextListWrapper.tabIndex = 0;
      // console.log(nextListWrapper);
      // clear out any contents from the next level nav
      const subMenuListWrapper = nextListWrapper.querySelector('.sub-menu-wrapper');
      subMenuListWrapper.innerHTML = '';
      subMenuListWrapper.append(clonedList);

      // build the heading link
      const headingHTML = nextListWrapper.querySelector('.sub-menu-title');
      headingHTML.innerHTML = '';
      const headingLink = linkClicked.dataset.link;
      headingHTML.insertAdjacentHTML('beforeend', `<a class="sub-menu-link" href="${headingLink}">${linkClicked.textContent.trim()}</a>`);
      // add the cloned node to the next level wrapper
      resetFocus(nextListWrapper);

      if (tabbed) {
        resetFocus(nextListWrapper);
      }
    }
  };

  const handleBackBtnEvent = (e) => {
    const backBtn = e.target;
    const startingListWrapper = backBtn.closest('.list-wrapper');
    const i = listWrappers.indexOf(startingListWrapper);
    // console.log(parentListWrapper);
    backBtn.tabIndex = -1;
    startingListWrapper.tabIndex = -1;
    // clear out starting List so it cant be tabbed to.
    startingListWrapper.querySelector('.sub-menu-wrapper').innerHTML = '';
    startingListWrapper.querySelector('.sub-menu-title').innerHTML = '';
    // remove the 'isVisible' Class from this .list-wrapper
    startingListWrapper.classList.remove(isVisibleClass);
    // gets the parents previous element sibling w/ the .is-active class and removes it??
    const endingListWrapper = listWrappers[i - 1];
    endingListWrapper.tabIndex = 0;
    // console.log(newActiveListWrapper);
    endingListWrapper.classList.remove(isActiveClass);
    // grab either the first btn of the newly active tab, or the first link if its a level 1 nav
    // const FirstLink = newActiveListWrapper.querySelector('.back-one-level, li');
    resetFocus(endingListWrapper);
  };

  // build level 2 nav on click from the level 1 nav
  level1Links.forEach((level1Link) => {
    level1Link.addEventListener('click', (e) => {
      // buildSubNavLevel2(e, e.target, false);
      // const currentListWrapper = e.target.closest('.list-wrapper');
      buildSubNav(e, e.target, false);
    });
  });

  // build the level 3 nav on click from the level 2 nav
  listWrapper2.addEventListener('click', (e) => {
    // buildSubNavLevel3(e, e.target, false);
    // console.log(e.target);
    if (e.target.nextElementSibling.classList.contains('sub-menu')) {
      buildSubNav(e, e.target, false);
    }
  });

  // builds the level 2 and level 3 nav on enter when tabbing through.
  document.addEventListener('keydown', (e) => {
    // if the user hits Enter
    if (e.keyCode === 13) {
      // if the user hits enter on the back button, we don't want to run this code to build a new nav level
      if (!e.target.classList.contains('back-one-level')) {
        const btn = e.target;
        const listLevel = btn.parentNode.parentNode;
        // console.log(listLevel, e, e.target);
        if (listLevel.classList.contains('level-1')) {
          buildSubNav(e, e.target, true);
        } else if (listLevel.classList.contains('level-2')) {
          buildSubNav(e, e.target, true);
        }
      }
    }
  });

  backOneLevelBtns.forEach((backOneLevelBtn) => {
    backOneLevelBtn.addEventListener('click', (e) => {
      handleBackBtnEvent(e);
    });
    backOneLevelBtn.addEventListener('keydown', (e) => {
      if (e.keyCode === 13) {
        handleBackBtnEvent(e);
      }
    });
  });
};

export default mobileNavNew;
